import React from "react";
import "../../Assessts/Styles/Home.scss";

import SlidingFrame from "./SlideingFrame";

import SAboutus from "../../ReUableComponents/SmallAboutus.jsx";

import IES from "../../Assessts/Images/Home/IES.svg";
import SGA from "../../Assessts/Images/Home/SGA.svg";
import SAO from "../../Assessts/Images/Home/SAO.svg";
import VSC from "../../Assessts/Images/Home/VSC.svg";
import SFD from "../../Assessts/Images/AboutUs/SS.svg";
import OAP from "../../Assessts/Images/Home/SSP/OAP.svg";
import CLR from "../../Assessts/Images/Home/SSP/CLR.svg";
import FANU from "../../Assessts/Images/Home/SSP/FANU.svg";

import CMS from "../../Assessts/Images/Home/ScholarshipTypes/CMS.png";
import DMS from "../../Assessts/Images/Home/ScholarshipTypes/DMS.png";
import HSS from "../../Assessts/Images/Home/ScholarshipTypes/HSS.png";

import AScholarships from "../../Assessts/Images/Home/AScholarships.svg";
import ENCP from "../../Assessts/Images/Home/ENCP.svg";

import ECIncome from "../../Assessts/Images/Home/EC-Income.png";
import CEPDF from "../../Assessts/Images/Home/CE-PDF.png";

import FAQS from "../../ReUableComponents/FAQS.jsx";
import POSSP from "../../Assessts/Images/Home/ScholarshiProcess.png";
// import NChapter from "../../Assessts/Images/Home/NewChapter.png";
import CEPDFF from "../../Assessts/Images/Home/CheckEligilibity.pdf";
import SlidingWithButtons from "./SlidingwithButtons.jsx";
import Patners from "./Patners.jsx";

const Home = () => {
    const OSSP = [
        { Name: "Scholarship Notice Release", BGC: "#E9EFFF", Content: "Scholarship announcement released outlining eligibility criteria & application timelines", icon: SGA },
        { Name: "Online Application Portal", BGC: "#E9FCFF", Content: "Teachers, community members, and volunteers recommend students who meet merit-based and financial need eligibility criteria.", icon: OAP },
        { Name: "Document Copy Submission", BGC: "#F5F5F5", Content: "Applicants submit required document hardcopies to respective chapters", icon: SAO },
        { Name: "Chapter Level Review", BGC: "#F8FFE9", Content: "Chapter coordinators verify  eligibility of application documents while following guidelines", icon: CLR },
        { Name: "Student  Interview", BGC: "#FFF2E7", Content: "Shortlisted students attend interviews assessing merit & need", icon: IES },
        { Name: "National Coordinator Review", BGC: "#F4ECFF", Content: "National coordinator reviews chapter recommendations ensuring fairness & accuracy", icon: VSC },
        { Name: "Final Approval by NSF-USA", BGC: "#FFEBEE", Content: " NSF-USA approves final scholar list for disbursement", icon: FANU },
        { Name: " Scholarship Disbursement", BGC: "#E8FFF2", Content: "Approved scholarship funds disbursed to students  via Direct Benefit Transfer", icon: SFD },
    ];
    const ScholarshipTypes = [
        { Img: CMS, Tittle: "College Merit Scholarships", Content: "North South Foundation offers merit scholarships for students admitted to professional courses including engineering, medicine, nursing, agriculture, pharmacy, supporting them throughout degree programs." },
        { Img: DMS, Tittle: "Designated Merit Scholarships", Content: "North South Foundation administers designated scholarships when donors choose specific colleges or courses, identifying eligible students and awarding targeted support outside the general scholarship pool." },
        { Img: HSS, Tittle: "High School Scholarships", Content: "North South Foundation supports students completing high school through designated scholarships funded by donors, helping deserving students study at selected schools of choice nationwide India." },
    ];
    const SEligibilityCriteria = [
        { Name: "National & State Level Exam Rank", icon: ENCP },
        { Name: "Academic Performance", icon: AScholarships },
        { Name: "Annual Family Income ≤ Rs. 2 lakhs", icon: ECIncome },
    ]
    return (
        <>
            <div className="mb-5 pb-5" style={{ position: "relative" }}>
                <SlidingFrame />
                <div className="Card  p-3 Banner-Details dflex gap-3 JCCenter alignitems">
                    <div style={{ backgroundColor: "#FFF6DB" }}>
                        <span className="Web-SubHeading">Our Mission</span>
                        <p>Ensuring equitable education access, nurturing empathetic leaders, and uniting volunteers to strengthen communities everywhere globally.</p></div>
                    <div style={{ backgroundColor: "#D7FFE2" }} >
                        <span className="Web-SubHeading">Our Vision</span>
                        <p>Advancing excellence in education, empathy, and social entrepreneurship to create inclusive, innovative, and compassionate societies.</p>
                    </div>
                </div>
            </div>

            <SAboutus />
<img src={POSSP} alt="Scholarship Selection Process" className="dflex alignitems w-100" style={{padding:"20px 45px",height:"80vh"}}/>
            {/* <div className="p-5 mt-5" style={{ backgroundColor: "#347462" }}>
                <div className="Web-MainHeading" style={{ color: "#fff" }}>Our Scholarship Selection Process</div>
                <div className="dflex gap-3 mt-3 OSSP">
                    {OSSP.map((item, index) => (
                        <div className="dflex gap-2 p-3 flexd-column JCCenter alignitems OSSP-Each" style={{ backgroundColor: item.BGC }}>
                            <span><img src={item.icon} alt={item.Name} /></span>
                            <div className="Web-SubHeading">{index + 1}. {item.Name}</div>
                            <div>{item.Content}</div>
                        </div>
                    ))}
                </div>
            </div> */}

            <div className="p-5">
                <div className="Web-MainHeading mb-3 " >Scholarship Types</div>
                <div className="dflex gap-5 STypes">
                    {ScholarshipTypes.map((item) => (
                        <div className="dflex gap-2 flexd-column JCCenter alignitems">
                            <img src={item.Img} alt={item.Tittle} className="w-100" />
                            <div className="Web-SubHeading">{item.Tittle}</div>
                            <div style={{ textAlign: "justify" }}>{item.Content}</div>
                        </div>
                    ))}</div>
            </div>
            <div>
                <div className="Web-MainHeading mb-3" >College Merit Scholarship Amounts</div>
                <div className="Scholarship-Table dflex flexd-column JCCenter alignitems">
                    <table >
                        <thead> <tr> <th>Course</th> <th>Duration</th> <th>Total Amount (₹)</th> </tr> </thead>
                        <tbody>
                            <tr> <td>Medicine (MBBS)</td> <td>5 years</td> <td>1.5 Lakhs</td> </tr>
                            <tr> <td>B.E., B.Tech (Including Lateral Entry), BDS, B.Pharma, B.Sc (Agriculture), B.Sc (Nursing)</td>
                                <td>4 years</td> <td>1.0 Lakhs</td> </tr>
                            <tr> <td>B.Sc B.Ed., & BA B.Ed.*</td> <td>4 years</td> <td>1.0 Lakhs</td> </tr>
                            <tr> <td>Diploma in Engineering, Diploma in Agriculture</td> <td>3 years</td> <td>45,000</td> </tr>
                        </tbody>
                    </table>
                    <div className="mt-2"><span style={{ color: "#EF5436" }}>Note :</span> *Limited to Regional Institutes of Education of NCERT located in Ajmer, Bhopal, Bhubaneshwar, Mysore, Shillong</div>
                </div>
            </div>


            <div className="Web-MainHeading mt-5 mb-3" >Eligibility Criteria</div>
            <div className="dflex gap-5 JCCenter mt-5 NCF-DetailsMainDiv p-0">
                {SEligibilityCriteria.map((item) => (
                    <div className="dflex flexd-column alignitems gap-2 ScholarShip">
                        <span>{item?.Name}</span>
                        <span className="ScholarShip-icon"><img src={item?.icon} alt={item?.Name} /></span>
                    </div>
                ))}
            </div>
            <div className="dflex gap-3 mt-4 mb-4 JCCenter Eligibility-Buttons">
                <button className="Website-Buttons" onClick={() => window.open("https://portal.northsouth.org/app6/MainTest.aspx?_gl=1*1k6hnm5*_ga*MTEzODQwNjc1MS4xNzQ4ODM5Njgz*_ga_NFGY5F210T*czE3NzAzNzM4MTMkbzMwJGcxJHQxNzcwMzc0NDY4JGo0OCRsMCRoMTkxNzc4OTA1Mw..", "_blank")}><img src={SAO} alt="Apply Now" className="h-50" /> Apply Now</button>
                <button className="Website-Buttons" onClick={() => window.open(CEPDFF, "_blank")}><img src={CEPDF} alt="Check Eligibility" /> Check Eligibility</button>
            </div>
            <SlidingWithButtons />
            <Patners />
            <FAQS />
            <div className="mt-3 pb-4 dflex JCCenter flexd-column alignitems">
                <div className="Web-MainHeading">Join us in making a difference</div>
                <div>Contact <span style={{ color: "#347462" }}>indiascholarships@northsouth.org</span> for further details.</div>
                {/* <div className="dflex  gap-3 mt-3 JMD">

                    <button className="Website-Buttons " onClick={() => window.open("https://portal.northsouth.org/app6/MainTest.aspx?_gl=1*1k6hnm5*_ga*MTEzODQwNjc1MS4xNzQ4ODM5Njgz*_ga_NFGY5F210T*czE3NzAzNzM4MTMkbzMwJGcxJHQxNzcwMzc0NDY4JGo0OCRsMCRoMTkxNzc4OTA1Mw..", "_blank")}><img src={SAO} alt="Apply Now" className="h-50" /> Apply Now</button>
                    <button className="Website-Buttons "> <img src={NChapter} alt="New Chapter" className="h-75" />Start a New Chapter</button>
                </div> */}
            </div>
        </>
    )
}
export default Home;